import { SectionLabel } from "@/components/yanre/SectionLabel";
import { Reveal, RevealLines } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

// GLOBAL REUSABLE — macro-detail editorial grid for YANRE engineering differentiation.
// Slots are data-driven; metrics only render when explicitly provided (verified).
export const DetailsDifference = ({ details, index }) => {
  const { t } = useLocale();
  return (
    <section className="section-darker relative overflow-hidden border-t border-carbon-700" data-testid="details-difference-section">
      <div className="grid-lines absolute inset-0 opacity-40" />
      <div className="container-edge relative py-16 lg:py-24">
        <Reveal>
          <SectionLabel index={index}>Engineered Differently</SectionLabel>
        </Reveal>
        <h2 className="mt-8 font-display text-4xl font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <RevealLines
            lines={[
              t("dd.h1a", "The difference"),
              <span key="d">
                {t("dd.h1b", "is in the details.")}
              </span>,
            ]}
          />
        </h2>
        <div className="mt-14 grid gap-px sm:grid-cols-2 lg:grid-cols-3" data-testid="details-grid">
          {details.map((d, i) => (
            <Reveal key={d.title} delay={i * 0.05} className={i === 0 ? "sm:col-span-2" : ""}>
              <div className="group relative flex h-full flex-col overflow-hidden border border-carbon-700 bg-carbon-900">
                <div className={`overflow-hidden ${i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                  <img
                    src={d.image}
                    srcSet={d.srcSet}
                    sizes={d.srcSet ? "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 700px" : undefined}
                    alt={t(`dd.${i}.t`, d.title)}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="relative border-t border-carbon-700 p-5 sm:p-6">
                  {d.metric && (
                    <span className="absolute -top-4 left-5 bg-signal px-2.5 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-white rtl:left-auto rtl:right-5">
                      {d.metric}
                    </span>
                  )}
                  <h3 className="font-display text-lg font-bold uppercase leading-tight text-white sm:text-xl">
                    {t(`dd.${i}.t`, d.title)}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-titanium/60">{t(`dd.${i}.s`, d.statement)}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
